import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { useShallow } from 'zustand/react/shallow';

import { Modals } from '@/helpers/modals';
import { useModalsStore } from '@/store';

import { ScJackpotMessage } from './styled';

export const JackpotMessage = () => {
  const { t } = useTranslation('jackpot');
  const { infoIcon: InfoIcon, images } = useTheme();
  const open = useModalsStore.use.open();

  const handleClick = () => {
    open(Modals.Deposit);
  };

  return (
    <ScJackpotMessage onClick={handleClick}>
      <InfoIcon />
      <p>{t('jackpotMessage')}</p>
      <images.arrowDownIcon.component />
    </ScJackpotMessage>
  );
};
